import "../styles/authForms.css";
import "../styles/form.css";

function ConfirmEmail() {
  return (
    <form className="single-forms">
      <h2>Confirmation</h2>
      <p>Please confirm email to proceed.</p>
    </form>
  );
}

export default ConfirmEmail;
